export { default as ListarDescuentos } from './Listar';
export { default as CrearDescuento } from './Crear';
